module.exports = __webpack_public_path__ + "img/sealImg1.a09c522d.png";